import { Caption } from "Content/Caption";
import { BlockContainer } from "./style";

export const Block = ({ caption, children, captioninblock, drawshadow }) => {
  return (
    <>
      {!captioninblock && (
        <Caption text={caption} inblock={captioninblock}></Caption>
      )}
      <BlockContainer drawshadow={!captioninblock || drawshadow}>
        {captioninblock && (
          <Caption text={caption} inblock={captioninblock}></Caption>
        )}
        {children}
      </BlockContainer>
    </>
  );
};
